<template>
  <div @click="onClick($event)" class="training-card">
    <div class="training-card__top">
      <div class="points">
        <p>{{ training.points }}</p>
        <p>{{ training.points == 1 ? 'ponto' : 'pontos' }}</p>
      </div>
      <img :src="training.image" alt="Imagem do Treinamento" />
      <div class="status-badge" :class="{ done: training.is_done }">
        <b-icon size="is-small" icon="check"></b-icon>
        <span>{{ training.is_done ? 'Realizado' : 'Não realizado' }}</span>
      </div>
    </div>
    <div class="training-card__bottom">
      <div class="title">{{ training.title }}</div>
      <div class="description">
        {{ training.short_description | slice(0, 120) }}...
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'training-card',
  props: ['training'],
  methods: {
    onClick(event) {
      this.$emit('click', event);
    },
  },
};
</script>

<style lang="scss" scoped>
.training-card {
  padding-top: 30px;
  max-width: 270px;

  &__top {
    position: relative;
    overflow: visible;

    .points {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      position: absolute;
      top: -30px;
      right: 0;
      left: 0;
      margin: auto;
      color: #fff;
      background: var(--color-primary);
      border-radius: 50%;
      height: 65px;
      width: 65px;
      z-index: 2;

      > p {
        width: fit-content;
        text-align: center;

        &:first-child {
          font-size: 1.2em;
          font-weight: bold;
        }

        &:last-child {
          font-size: 0.8em;
        }
      }
    }

    img {
      width: 270px;
      height: 200px;
      border-radius: 12px;
      object-fit: cover;
    }

    .status-badge {
      display: flex;
      align-content: center;
      justify-content: center;
      position: absolute;
      bottom: -8px;
      right: 0;
      left: 0;
      margin: auto;
      text-transform: uppercase;
      font-size: 0.9em;
      width: fit-content;
      padding: 8px 12px;
      border-radius: 6px;

      &.done {
        color: #fff;
        background: #50c480;

        .icon {
          display: unset;
          margin-right: 5px;
        }
      }

      &:not(.done) {
        background: #fff;
        border: 1px solid var(--color-primary);
        color: var(--color-primary);
      }

      .icon {
        display: none;
      }
    }
  }

  &__bottom {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    margin-top: 20px;
    border-left: 8px solid var(--color-primary);
    padding: 12px;
    min-height: 90px;

    .title {
      font-size: 0.9em;
      font-weight: 400;
      margin-bottom: 8px;
      text-transform: uppercase;
    }

    .description {
      font-size: 0.8em;
      color: var(--color-text-light);
      white-space: normal;
    }
  }
}
</style>
